export default __webpack_public_path__ + "static/assets/med_x_eye_drops_mask.23a92e80.png";